import React, { useState } from 'react';
import { AccountPremiumToast } from '../components/account/AccountPremiumToast';
import { AccountProfileBand } from '../components/account/AccountProfileBand';
import {
  AccountSettingsDialogs,
  type AccountSettingsDialog,
} from '../components/account/AccountSettingsDialogs';
import { AppPanelShell } from '../components/layout/AppPanelShell';
import { useAccountSettingsState } from '../hooks/useAccountSettingsState';

/** Merged profile + account settings — single My Account page. */
export const DashboardPage: React.FC = () => {
  const settings = useAccountSettingsState();
  const [openDialog, setOpenDialog] = useState<AccountSettingsDialog | null>(null);

  const open = (dialog: AccountSettingsDialog) => {
    if (dialog === 'phone') settings.setPhoneError('');
    if (dialog === 'location') settings.setLocationError('');
    if (dialog === 'security') settings.setPasswordError('');
    setOpenDialog(dialog);
  };

  return (
    <>
      <AccountPremiumToast toast={settings.toast} onClose={settings.closeToast} />
      <AppPanelShell title="My Account">
        <AccountProfileBand
          client={settings.client}
          dpLoading={settings.dpLoading}
          dpError={settings.dpError}
          onFileChange={settings.handleFileChange}
          onClearDpError={() => settings.setDpError('')}
          onEditName={() => open('name')}
          onEditPhone={() => open('phone')}
          onEditLocation={() => open('location')}
          onEditSecurity={() => open('security')}
          onLogout={() => void settings.handleLogout()}
          logoutLoading={settings.logoutLoading}
        />
      </AppPanelShell>

      <AccountSettingsDialogs
        openDialog={openDialog}
        onCloseDialog={() => setOpenDialog(null)}
        clientEmail={settings.client?.email}
        name={settings.name}
        hasGoogle={settings.client?.has_google}
        hasPassword={settings.client?.has_password}
        nameLoading={settings.nameLoading}
        nameError={settings.nameError}
        currentPassword={settings.currentPassword}
        newPassword={settings.newPassword}
        confirmPassword={settings.confirmPassword}
        showCurrentPassword={settings.showCurrentPassword}
        showNewPassword={settings.showNewPassword}
        showConfirmPassword={settings.showConfirmPassword}
        passwordLoading={settings.passwordLoading}
        passwordError={settings.passwordError}
        onNameChange={settings.setName}
        onSaveName={settings.handleSaveName}
        phone={settings.phone}
        phoneLoading={settings.phoneLoading}
        phoneError={settings.phoneError}
        countries={settings.countries}
        states={settings.states}
        country={settings.country}
        state={settings.state}
        locationLoading={settings.locationLoading}
        locationError={settings.locationError}
        onPhoneChange={settings.setPhone}
        onSavePhone={settings.handleSavePhone}
        onCountryChange={settings.setCountry}
        onStateChange={settings.setState}
        onSaveLocation={settings.handleSaveLocation}
        onClearPasswordError={() => settings.setPasswordError('')}
        onCurrentPasswordChange={settings.setCurrentPassword}
        onNewPasswordChange={settings.setNewPassword}
        onConfirmPasswordChange={settings.setConfirmPassword}
        onToggleCurrentPassword={() => settings.setShowCurrentPassword(!settings.showCurrentPassword)}
        onToggleNewPassword={() => settings.setShowNewPassword(!settings.showNewPassword)}
        onToggleConfirmPassword={() => settings.setShowConfirmPassword(!settings.showConfirmPassword)}
        onSubmitPassword={settings.handleChangePassword}
      />
    </>
  );
};
